import { isTelegramMockEnabled } from "@/lib/telegramMock";

// We defer loading of the heavy 'posthog-js' package until actually initializing.
// This keeps it out of the critical path / initial React hydration bundle.
let loadedPosthog: typeof import("posthog-js") | null = null;
let initStarted = false;

const POSTHOG_API_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST_URL = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

export const initPostHog = async () => {
  if (typeof window === "undefined") return;
  if (initStarted) return; // idempotent safeguard
  initStarted = true;
  if (isTelegramMockEnabled()) {
    if (import.meta.env.DEV) {
      console.log("[PostHog] Skipping initialization in telegram mock mode");
    }
    // If something already initialized PostHog earlier (race), shut it down
    try {
      const anyWindow = window as unknown as {
        posthog?: {
          reset?: () => void;
          opt_out_capturing?: () => void;
          shutdown?: () => void;
        };
      };
      if (anyWindow.posthog && typeof anyWindow.posthog.reset === "function") {
        anyWindow.posthog.reset?.();
        anyWindow.posthog.opt_out_capturing?.();
        anyWindow.posthog.shutdown?.();
        console.log("[PostHog] Forced shutdown after mock detection");
      }
    } catch (e) {
      console.warn("[PostHog] shutdown attempt error", e);
    }
    return; // Do not initialize in mock mode to avoid noise
  }
  if (POSTHOG_API_KEY && POSTHOG_HOST_URL) {
    try {
      if (!loadedPosthog) {
        loadedPosthog = await import("posthog-js");
      }
      const posthog = loadedPosthog.default;
      posthog.init(POSTHOG_API_KEY, {
        api_host: POSTHOG_HOST_URL,
        capture_pageview: true,
        capture_pageleave: true,
      });
    } catch (e) {
      console.warn("[PostHog] dynamic import/init failed", e);
    }
  }
};
